import React from 'react'
import { IconProps } from '../../../common/types'

const ClientBuilding: React.FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 21.6875V5.6875C19 4.58293 18.1046 3.6875 17 3.6875H7C5.89543 3.6875 5 4.58293 5 5.6875V21.6875M19 21.6875L21 21.6875M19 21.6875H14M5 21.6875L3 21.6875M5 21.6875H10M9 7.68748H10M9 11.6875H10M14 7.68748H15M14 11.6875H15M10 21.6875V16.6875C10 16.1352 10.4477 15.6875 11 15.6875H13C13.5523 15.6875 14 16.1352 14 16.6875V21.6875M10 21.6875H14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ClientBuilding
